import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phone'
})
export class PhonePipe implements PipeTransform {

  transform(value: any, args?: any): any {
      if (value == null || value.length == 0)
          return "";

      let newPhone = '';
      switch (value.length) {
          case 10:
          case 9:
          case 8:
          case 7:
              newPhone = '(' + value.slice(0, 3) + ') ' + value.slice(3, 6) + '-' + value.slice(6);
              break;
          case 6:
          case 5:
          case 4:
              newPhone = '(' + value.slice(0, 3) + ') ' + value.slice(3, 6);
              break;
          default:
              newPhone = value;
              break;

      }
      return newPhone;
  }

}
